import { render, staticRenderFns } from "./managers.vue?vue&type=template&id=11a3b4c4"
import script from "./managers.vue?vue&type=script&lang=js"
export * from "./managers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports